import React from 'react';
import PropTypes from 'prop-types';

// material-ui components
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import { loginCardStyle } from './styles.jsx';
import Button from 'Common/CustomButtons/Button';
import { FormattedMessage } from 'react-intl';

function RegisterCard({ ...props }) {
    const {
        classes,
        cardSubtitle,
        cardWelcomeSubtitle,
        socials,
        handleRegister
    } = props;

    return (
        <div className='register-tab-content'>
            <CardContent className={ classes.cardContent + ' top-register'}>
                <p className={ classes.cardSubtitle }>{ cardWelcomeSubtitle }</p>
                <Button fullWidth color="primary" onClick={handleRegister} >
                    <FormattedMessage id="button.register" />
                </Button>
                <p className={ classes.cardSubtitle }>{ cardSubtitle }</p>
                <div className='register-tab-socials'>
                    { socials }
                </div>
            </CardContent>
        </div>
    );
}

RegisterCard.propTypes = {
    classes: PropTypes.object.isRequired,
    cardSubtitle: PropTypes.node,
    cardWelcomeSubtitle: PropTypes.node,
    socials: PropTypes.node,
    handleRegister: PropTypes.func.isRequired
};

export default withStyles(loginCardStyle)(RegisterCard);



// WEBPACK FOOTER //
// ./src/common/Cards/RegisterCard.jsx